export default {
  setItem(key, value) {
    let val = value
    if (typeof value === 'object' && value !== null) {
      val = JSON.stringify(value)
    }
    localStorage.setItem(key, val)
  },
  getItem(key) {
    const value = localStorage.getItem(key)
    try {
      return JSON.parse(value)
    } catch (error) {
      return value
    }
  }
}
